module.exports = __webpack_public_path__ + "static/img/banner.27ed8a13.png";